import { render, staticRenderFns } from "./MerchantPayment.vue?vue&type=template&id=266873be&scoped=true"
import script from "./MerchantPayment.vue?vue&type=script&lang=js"
export * from "./MerchantPayment.vue?vue&type=script&lang=js"
import style0 from "./MerchantPayment.vue?vue&type=style&index=0&id=266873be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266873be",
  null
  
)

export default component.exports